import { createFileRoute, Outlet } from '@tanstack/react-router';

export const Route = createFileRoute('/w/employee-templates')({
  staticData: { breadcrumb: 'Employee Templates', breadcrumbKey: 'K_BREADCRUMB_EMPLOYEE_TEMPLATES' },
  component: EmployeeTemplatesLayout,
});

function EmployeeTemplatesLayout() {
  return <Outlet />;
}
